import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants';
import { City } from 'src/app/core/models/location.model';

@Component({
  selector: 'app-city-content',
  templateUrl: './city-content.component.html',
  styleUrls: ['./city-content.component.scss',],
})
export class CityContentComponent {

  @Output() citySelected = new EventEmitter<City>();
  @Input() cities: City[] = [];
  isLoading: boolean = false;

  constructor(
    private _router: Router
  ) { }

  onCitySelected(city: City) {
    localStorage.setItem(AppConstants.CURRENT_CITY_KEY, city.name);
    this._router.navigate([], {
      queryParams: {
        city: city.name.toLowerCase(),
        page: 1,
      },
      queryParamsHandling: 'merge',
    });
    this.citySelected.emit(city);
  }

}
